<template>
  <b-row no-gutters>
    <b-col cols="12" lg="4" class="pt-4 px-4">
      <template v-if="!!references">
        <div v-for="(url, desc) in references.research_links" :key="url" class="mb-1">
          <b-link :href="url" target="_blank" v-html="desc"/>
        </div>
      </template>
      <template v-else>Loading...</template>
    </b-col>
    <b-col cols="12" lg="8" class="pt-4 px-4 pb-4">
      <template v-if="!!references">
        <modal-row label="Ref By" v-if="references.references.item">{{
            references.references.item.createdby_user.name
          }}
        </modal-row>
      </template>
      <modal-row label="Reference">{{ message.item_ref }}</modal-row>
      <modal-row label="State">{{ message.state_description }}</modal-row>
      <modal-row :label="message.is_sent_message ? 'To' : 'From'">{{ message.address_display }}</modal-row>
      <modal-row v-if="otherRecipients.length" label="Also To">{{ otherRecipients.join(', ') }}</modal-row>
      <modal-row v-if="ccRecipients.length" label="CC">{{ ccRecipients.join(', ') }}</modal-row>
      <modal-row :label="message.is_sent_message ? 'Sent' : 'Received'">{{ message.created | date }} via
        {{ message.source_description }}
        <div v-if="message.is_sent_message">By
          {{ message.send_by_user ? message.send_by_user.name : 'N/A' }}
        </div>
      </modal-row>
      <modal-row v-if="message.assign_date" label="Assigned">
        To {{ message.assigned_to_user ? message.assigned_to_user.name : 'N/A' }}
        <div class="font-italic">by
          {{ message.assign_by_user ? message.assign_by_user.name : 'N/A' }}
          on {{ message.assign_date | date }}
        </div>
      </modal-row>
      <modal-row v-if="message.done_date" label="Done">
        <div>{{ message.done_date | date }}</div>
        <div class="font-italic">By {{ message.done_by_user && message.done_by_user.name }}</div>
      </modal-row>
      <modal-row v-if="message.delete_date" label="Delete">
        <div>{{ message.delete_date | date }}</div>
        <div class="font-italic">By {{ message.delete_by_user && message.delete_by_user.name }}</div>
      </modal-row>
      <modal-row v-if="message.unassign_date" label="Unassigned">
        {{ message.unassign_date | date }}
      </modal-row>

      <div class="mt-3" v-if="message.apiData">
        <modal-row v-if="message.apiData.name" label="Name">
          {{ message.apiData.name }}
        </modal-row>
        <modal-row v-if="message.apiData.phone" label="Phone">
          {{ message.apiData.phone }}
        </modal-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "message-info",
  props: {
    message: Object
  },
  data() {
    return {
      references: null,
    }
  },
  computed: {
    // shown as plain labels: who else was on the thread, so a reader can see
    // the CC list without opening a reply
    otherRecipients() {
      return ((this.message && this.message.to_addresses) || [])
          .map(a => a.name ? `${a.name} <${a.email}>` : a.email)
    },
    ccRecipients() {
      return ((this.message && this.message.cc_addresses) || [])
          .map(a => a.name ? `${a.name} <${a.email}>` : a.email)
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.asyncAction(this.message._links.references_url.href, this.message._links.references_url.method, {
        noload: true,
        quiet: true,
      }).then((v) => this.references = v)
    }
  }
}
</script>

<style scoped>

</style>